// Commands sent from Main UI thread to the StreamWorker
/* eslint-disable */
export const AudioCommand = {
  // Activate Agent is deprecated
  ACTIVATE_AGENT: 'ACTIVATE_AGENT',               // Activate this agent to be primary
  AUTH: 'AUTH',                                   // Socket Auth request
  CONFIGURATION: 'CONFIGURATION',                 // Context/Configuration/UI Data for audio being sent
  TRANSFER_PORT: 'TRANSFER_PORT',                 // [AudioWorklets ^Chrome 64]
  SPEECH_CONFIG: 'SPEECH_CONFIG',                 // Send speech config to ms-cap
  STOP: 'STOP'                                    // Stop Audio Recording
}
